module.exports = __webpack_public_path__ + "static/media/checkbox-empty-focussed.13868062.svg";